<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="page template-padding container" v-else-if="loaded" >
        
        <div class="row" >
            
            <div class="col-12" >
    
                <b-card no-body class="atlass-tabs atlass-tabs-colored" >
                    <b-tabs card>

                        <b-tab title="Raw JSON" active>
                            <b-card-text  >
                                
    <pre id="script-json" class="prettyprint mb-0 ">
        {
          "APPKEY": "{{data.organizationID}}",
          "firstname": "John",
          "lastname": "Doe",
          "email": "John@doe.com",
          "clientIP": "71.23.54.682",
          "orderName": "Order number 215645675733",
          "orderPrice": "349",          
        }
    </pre>

                                <button class="btn btn-copy" @click="copyScript( 'json' )" > <font-awesome-icon icon="copy"  class="cursor-pointer graymedium-color h4" ></font-awesome-icon> </button>
                                
                            </b-card-text>
                        </b-tab>

                        <b-tab title="PHP" >
                            <b-card-text  >
                                
    <pre id="script-php" class="prettyprint mb-0 ">
        $data = array(
            "APPKEY" => "{{data.organizationID}}",
            "firstname" => "John",
            "lastname" => "Doe",
            "email" => "john.doe@gmail.com",
            "IP" =>  "71.23.54.682",
            "orderName" => "Order number 215645675733",
            "orderPrice" => 349,         
        );

        $payload = json_encode($data);

        //print $payload;

        // Prepare new cURL resource
        $ch = curl_init('https://tracker-288417.ew.r.appspot.com/order/add');
        curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
        curl_setopt($ch, CURLINFO_HEADER_OUT, true);
        curl_setopt($ch, CURLOPT_POST, true);
        curl_setopt($ch, CURLOPT_POSTFIELDS, $payload);

        // Set HTTP Header for POST request 
        curl_setopt($ch, CURLOPT_HTTPHEADER, array(
            'Content-Type: application/json',
            'Content-Length: ' . strlen($payload))
        );

        // Submit the POST request
        $result = curl_exec($ch);

        // Close cURL session handle
        curl_close($ch);

        var_dump( $result );
    </pre>

                                    <button class="btn btn-copy" @click="copyScript( 'php' )" > <font-awesome-icon icon="copy"  class="cursor-pointer graymedium-color h4" ></font-awesome-icon> </button>
                            
                            </b-card-text>
                        </b-tab>

                        <b-tab title="Node.js" class="d-none"  >
                            


                        </b-tab>

                        <b-tab title="Java" class="d-none"  >

                            

                        </b-tab>

                    </b-tabs>
                </b-card>
                
            </div>
            
            <div class="col-12" >
                
    
                
            </div>
            
            
            
        </div>
        
    </div>
</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import helper from '@/helpers/helpers.js';

export default {
    name: 'API',
    components:{
        
    },
    props: {
    },
    data: function(){
        return {
            loaded: false,
            data:{},
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        
        //this.get_data();
        
        let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
        this.data.organizationID = orgID;
        
        setTimeout(function(){ this.loaded = true }.bind(this), 100 );
        
    },
    beforeDestroy() {
    },
    methods: {
         get_data(){
          
            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            //console.log( user )
                        
            const db = firebase.firestore();
            var ref = db.collection('users').doc( user.userID )
            
            return ref.get()
                .then((snapshot) => {
                    console.log(snapshot.data())
                    this.data = snapshot.data()
                    this.data.id = snapshot.id
                    this.loaded = true;
                })
          
        },
        formatData(unix){
            return this.$moment.unix(unix).format( 'MMM D, HH:mm' )
        },
        routePrimaryLead(ID){
            this.$router.push({
                name: 'LeadPage',
                params: { ID: ID }
            });
        },
        submit(){
            console.log( this.data )
        },
        copyScript( type ){
            
            var range = document.createRange();
            range.selectNode(document.getElementById("script-"+type));
            window.getSelection().removeAllRanges(); // clear current selection
            window.getSelection().addRange(range); // to select text
            document.execCommand("copy");
            window.getSelection().removeAllRanges();// to deselect
            
            this.$toast.success({
                title:'Success',
                message:  'Copied to clipboard!'
            })
            
        }
    },
    watch: {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
    .btn-copy{
        position: absolute;
        top: 0;
        right: 0;
        margin-top: 44px;
    }
    
</style>



// WEBPACK FOOTER //
// src/templates/setup/api.vue